import React, { FC } from 'react';
import s from './toyDraftCard.module.scss';
import { toyDraft } from '@prisma/client';
import cn from 'classnames';
import { Button } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import { Avatar } from '@components/UIKit/Avatar/Avatar';
import { useProfile } from '@hooks/TRPC_Hooks/useProfile';
import { useRouter } from 'next/router';
import { useGetSingleByDraft } from '@services/toys/hooks/useGetSingleByDraft';
import { LinksEnum } from '@specs/navigation';
import { RarityIcon } from '@components/UIKit/RarityIcon/RarityIcon';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
interface Props extends toyDraft {}
export const ToyDraftCard: FC<Props> = ({
  id,
  imageId,
  name,
  raritytype,
  status
}) => {
  const router = useRouter();
  const {
    translate: tr
  } = useTranslation();
  const {
    data: profile,
    isLoading: isLoadingProfile
  } = useProfile();
  const {
    data: toy,
    isLoading: isLoadingToy
  } = useGetSingleByDraft({
    draftId: id
  });
  const clickHandler = async () => {
    if (!toy) return;
    await router.push({
      pathname: LinksEnum.TOY,
      query: {
        slug: toy.slug
      }
    });
  };
  const isLoading = isLoadingToy || isLoadingProfile;
  return <div className={cn(s.toyDraftCard, status === 'EXPORTED' && s.toyDraftCard_exported)} data-sentry-component="ToyDraftCard" data-sentry-source-file="ToyDraftCard.tsx">
            <div className={s.toyDraftCard__top}>
                <div className={s.toyDraftCard__row}>
                    <Avatar profile={profile} srcSet={[{
          height: 24,
          width: 24,
          minMedia: 0
        }]} isLoading={isLoading} data-sentry-element="Avatar" data-sentry-source-file="ToyDraftCard.tsx" />
                    {raritytype && <RarityIcon rarityId={raritytype} width={24} height={24} />}
                </div>
                <OptimizedImage boxClassName={cn(s.toyDraftCard__image, '_shadow')} path={'/toys/cards'} cdnId={imageId} alt={name} fill data-sentry-element="OptimizedImage" data-sentry-source-file="ToyDraftCard.tsx" />
            </div>
            <div className={s.toyDraftCard__main}>
                <div className={cn(s.toyDraftCard__name, '_ellipsis')}>
                    {name}
                </div>
                <div className={cn(s.toyDraftCard__shortid, '_ellipsis')}>
                    {isLoading ? tr({
          id: 'btn.loading'
        }) : profile?.shortid}
                </div>
            </div>
            <Button id='default_button' color={status !== 'EXPORTED' ? 'Zhen Zhu Bai Pearl' : 'White'} size={'medium'} onClick={clickHandler} disabled={status !== 'EXPORTED'} loading={isLoading} icons={status === 'EXPORTED' ? {
      left: {
        name: 'toys'
      }
    } : undefined} data-sentry-element="Button" data-sentry-source-file="ToyDraftCard.tsx">
                {tr({
        id: status !== 'EXPORTED' ? 'public.profile.filter.under.moderation' : 'btn.to.figure'
      })}
            </Button>
        </div>;
};